// extracted by mini-css-extract-plugin
module.exports = {"OwcExpandable":"BookingAccessControl_OwcExpandable__1lqEn"};